module.exports = __webpack_public_path__ + "assets/HKNova-Light.woff2";


//////////////////
// WEBPACK FOOTER
// ./fonts/HKNova-Light.woff2
// module id = 138
// module chunks = 0